module.exports = __webpack_public_path__ + "static/img/bg-id.0f5e8aa9.png";